// @flow

import React, { type Element, useEffect, useState } from 'react'
import { TextField } from '@material-ui/core'
import {
  useValidationResult,
  handleChange,
  handleBlur,
  getErrorMsg,
} from '../../../../lib/CoreValidations'
import { core } from '../../../../lib/WasmCache'
import FormData from './FormData'

type Props = {
  value: string,
  setValue: (string) => void,
  setIsValid: (boolean) => void,
  serverError: string,
  setServerError: ($Keys<FormData>, string) => void,
}

function FacilityCodeField({
  value,
  setValue,
  setIsValid,
  serverError,
  setServerError,
}: Props): Element<typeof React.Fragment> {
  const [validationResult, onChange, onBlur] = useValidationResult(core.validatePrivateFacilityCode)
  const [isChanging, setIsChanging] = useState(false)

  const [error, setError] = useState('')

  useEffect(() => {
    setError(getErrorMsg(validationResult))
    setServerError('facilityCode', '')
  }, [setServerError, validationResult])

  useEffect(() => {
    if (serverError) {
      setError(serverError)
    }
  }, [serverError])

  return (
    <TextField
      id="facility-code"
      label="Private Office Facility Code"
      variant="outlined"
      fullWidth
      required
      error={!(validationResult.is_success || isChanging) || !!serverError}
      helperText={!isChanging && (error ? 'Facility Code ' + error : error)}
      value={value}
      onChange={(e) => {
        setIsChanging(true)
        handleChange(e.target.value, onChange, setIsValid, setValue)
      }}
      onBlur={(e) => {
        setIsChanging(false)
        handleBlur(e.target.value, onBlur, setIsValid)
      }}
      inputProps={{ maxLength: 5 }}
    />
  )
}

export default FacilityCodeField
